// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__21dyz","info":"Note_info__2C6bn","note":"Note_note__I82Fr","actions":"Note_actions__3RXz_"};